/**
 * Mismo algoritmo que net.tecgurus.chambia.util.SlugUtil (backend) — necesario
 * para construir/leer las mismas URLs amigables en ambos lados sin desincronizarse.
 */
export function slugify(texto: string): string {
  if (!texto) return '';
  return texto
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}
